const en = {
  clusterPage: {
    title: 'Clusters',
    createNewCluster: 'Create New Cluster',
    createConsentFlow: 'Configure Azure clusters',
    configureAzureClusterButtonTooltips: {
      successful: 'Azure deployment completed successfully.',
      inProgress: 'Azure deployment already in-progress.',
      requireAzureOffer: 'Azure deployment requires offer from tackle.',
    },
    secrets: {
      titlle: 'Database Credentials',
      dbConnection: 'DB Connection:',
      dbUsername: 'DB Username:',
      dbPassword: 'DB Password:',
    },
    pendingUpdates: {
      title: 'The cluster has a scheduled update at {date}',
      startupTitle:
        'The cluster has a scheduled update at the next cluster startup.',
    },
  },
  knowIncortaBanner: {
    incortaCommunity: 'Incorta Community',
    join: 'Join',
    incortaOverview: 'Incorta Overview Demo',
    watch: 'Watch',
    incortaDocumentation: 'Incorta Documentation',
    freeTraining: 'Free Training',
    start: 'Start',
  },
  clusterServerConfigurationList: {
    title: 'SQL Interface for External BI Tools',
  },
  clustersPage: {
    clusterTypes: {
      incortaCluster: 'Incorta cluster',
      azureCluster: 'Azure cluster',
    },
    azureCreationClusterCard: {
      header: 'Deploying Azure Environment',
      step: 'Step',
      nextStep: 'Next',
      info: {
        currentVersion: 'Current Version ',
        size: 'Size ',
        region: 'Region ',
        autoSuspend: 'Auto-suspend ',
      },
      footer: {
        status: 'Status ',
        preparing: 'Preparing...',
        working: 'Working...',
        failed: 'Failed.',
        canceled: 'Canceled',
        viewDetails: 'View Details...',
      },
      errorModal: {
        title: 'Azure Cluster Error Details',
        createdAt: 'Created at',
        error: 'Error',
        copyToClipboardBtn: 'Copy To Clipboard',
        okBtn: 'OK',
        copySuccessful: 'Error Copied Successfully',
      },
    },
  },
  consentFlow: {
    formTitle: 'Configure your Azure clusters',
    formSubtitle: "Only one step and you're good to go!",
    envName: 'Environment Name',
    envNamePlaceholder: 'Incorta',
    envNameTooltip:
      "We'll create two clusters (environments) based on this name—one for development and one for production (e.g., Incorta-DEV and Incorta-PROD).",
    envNameRequired: 'Please enter a valid environment name.',
    envNameMinimumCount: 'Name must be at least 3 characters.',
    envNameMaximmumCount: 'Name cannot be longer than 10 characters.',
    azureSubID: 'Azure Subscription ID',
    azureSubIDPlaceholder: '00000000-0000-0000-0000-000000000000',
    azureRG: 'Azure Resource Group Name',
    azureRGPlaceholder: 'Resource Group Name',
    azureRGTooltip:
      'Incorta recommends creating the resource group in the same location as the resources region.',
    resourceGroupRequired: 'Please enter your Azure Resource Group Name.',
    resourceRegionSelection: 'Resources Region Selection',
    resourceRegionSelectionPlaceholder: 'Select',
    subIDRequired: 'Please enter your Azure Subscription ID.',
    subIDValidRequired:
      'Please enter a valid subscription ID. It must match the format 00000000-0000-0000-0000-000000000000 and it only accepts alphanumeric characters.',
    subCredRequired: 'Please enter Azure Subscription Information Output.',
    azureSubscriptionInfoOutputPlaceholder: 'Paste output here',
    resourceRegionSelectionRequired: 'Please select a Resource Region.',
    azureCloudShell: 'Azure Cloud Shell',
    commandRequiredGoTo: 'Go to ',
    commandRequiredRun: ' and run the following command: ',
    commandRequiredTooltip:
      'Copy the following command and run it on {azureCloudShell}, then paste the output under Azure subscription information.',
    spCommand: `az ad sp create-for-rbac --name IncortaSP-<Environment name> --role owner --scopes /subscriptions/<subscription_id>/resourceGroups/<resourcegp_name>`,
    azureCommandCopyTooltip: 'Copy Command',
    azureCommandCantCopyTooltip:
      'In order to copy, please make sure to enter a valid environment name, subscription ID, and resource group name.',
    azureCommandCopySuccessful: 'Azure Command has been copied successfully.',
    networks: 'Networks',
    networksTooltip:
      'Use one of the existing networks you have, or let Incorta provide a new network.',
    newNetwork: 'New Network',
    existingNetwork: 'Existing Network',
    networkName: 'Network Name',
    networkNameTooltip: 'Provide the name of your existing virtual network',
    networkNameRequired: 'Please enter a Network Name.',
    addYourNetworkSubnets: 'Add your Network Subnets',
    subnets: {
      subnetRequiredAsterisk: '* ',
      incortaSubnet: 'Incorta Subnet',
      subnetPlaceholderPrefix: 'Example: ',
      incortaSubnetPlaceholder: '172.16.0.0/14',
      sparkSubnet: 'Spark Subnet',
      sparkSubnetPlaceholder: '172.20.0.0/14',
      publicSubnet: 'Public Subnet',
      publicSubnetPlaceholder: '172.24.0.0/24',
      databaseSubnet: 'Database Subnet',
      databaseSubnetPlaceholder: '172.24.1.0/24',
      loadbalancerSubnet: 'Load Balancer Subnet',
      loadbalancerSubnetPlaceholder: '172.24.2.0/24',
    },
    networkSubnetsRequired: 'Please complete the Network Subnets',
    networkConnectionSuccessful: 'Network Connection Test successful',
    networkConnectionFailed: 'Network Connection Test failed',
    cancelButton: 'Cancel',
    submitButton: 'Submit',
    submittingStatus: {
      validating: 'Validating...',
      validationSuccessful: 'Validation successful',
    },
    submissionSuccess:
      'Deploying Incorta on your Azure subscription has started. Please wait 45-50 minutes for your clusters creation.',
    submissionError: 'Something went wrong. Please try again.',
  },
  clusterForm: {
    clusterPlatformField: {
      label: 'Cluster Deployment',
      placeholder: 'Select Your Platform',
      requiredMessage: 'Please select your Platform',
      incortaSaasCloud: 'Incorta SaaS Cloud (GCP)',
      incortaSaasCloudAzure: 'Incorta SaaS Cloud (AZURE)',
      selfHostedIncortedOnAzure: {
        mainText: 'Self-hosted Incorta on Azure',
        configureFirst: '. (Please Configure Azure Clusters first)',
        waitForConfigure:
          '. (Please Wait for Configuring Azure Clusters to be finished)',
      },
    },
    clusterName: 'Cluster Name',
    clusterNameHint: {
      gc: 'Cluster name can be a minimum of 3 characters long (Alphabet english letters, numbers, dashes or combination), no spaces are allowed, can’t start with numbers and can’t begin or end with dash. Example: incorta-101.',
      azure:
        'Cluster name can be a minimum of 3 characters long (English lowercase alphanumerics) and maximum of 8 characters.',
    },
    clusterNameRequired: 'Please input your Cluster Name!',
    clusterNamePlaceholder: 'Incorta-101',
    clusterDiskSizeLabel: 'Disk Size',
    clusterDiskSizeRequired: 'Please input your Disk Size',
    clusterDiskSizePlaceholder: 'Disk Size',
    clusterSizeLabel: 'Cluster Size',
    clusterSizeOptimizationLabel: 'Cluster Configuration Optimization',
    clusterSizeRequired: 'Please select your Size!',
    clusterSizeUnitGB: 'GB',
    clusterSizeExtra: `IPU refers to Incorta Power Units. To request an increase for these limits. {supportLink}.`,
    clusterVersionLabel: `Incorta Version`,
    clusterRegionLabel: `Cluster Region`,
    clusterRegionDefaultOption: {
      azure: 'Already Configured',
    },
    clusterVersionRequired: 'Please select your Incorta Version!',
    clusterRegionRequired: 'Please select your Cluster Region!',
    clusterRegionUpgradeToPermium:
      'Upgrade to a Premium account to create clusters in other regions',
    clusterVersionPlaceholder: 'Select your Incorta Version',
    clusterRegionPlaceholder: 'Select your Cluster Region',
    clusterTenantLabel: 'Tenant Content',
    clusterTenantRequired: 'Please select your Tenant Content!',
    clusterTenantPlaceholder: 'Select your Tenant Content',
    clusterDataAppLabel: 'Data Application Tenant',
    clusterDataAppPlaceholder: 'Select Data Application',
    clusterDataAppHint:
      'The selected data application will be installed automatically with the created cluster',
    clusterOptimizationHint: {
      analytics:
        'Mainly used for analytics-intensive workloads, the analytics size will be bigger than the loader size',
      loader:
        'Mainly used for loader-intensive workloads, the loader size will be bigger than the analytics size',
      balanced:
        'Usually for common workloads, the analytics and loader are equally in size',
    },
    clusterInstallationLabel: 'Installation',
    clusterInstallationRequired: 'Please select Incorta installation type!',
    clusterInstallationPlaceholder: 'Select your Installation',
    clusterAliveLabelTitle: 'Keep alive',
    clusterAliveLabelHint:
      'After a period of inactivity the cluster will sleep, turn on to keep it alive.',
    clusterPythonPackagesLabel: 'REQUIRED PYTHON PACKAGES',
    clusterPythonPackagesExtra:
      'Should only contain Python packages which are compatible with pip.',
    clusterPythonPackagesPlaceholder: '"Ex: pandas, numpy"',
    clusterCreateButton: 'Create',
    clusteCancelButton: 'Cancel',
  },
  region: {
    'asia-east1': 'Asia-East1 (Taiwan)',
    'asia-east2': 'Asia-East2 (Hong Kong)',
    'asia-northeast1': 'Asia-Northeast1 (Tokyo)',
    'asia-northeast2': 'Asia-Northeast2 (Osaka)',
    'asia-northeast3': 'Asia-Northeast3 (Seoul)',
    'asia-south1': 'Asia-South1 (Mumbai)',
    'asia-south2': 'Asia-South2 (Delhi)',
    'asia-southeast1': 'Asia-Southeast1 (Singapore)',
    'asia-southeast2': 'Asia-Southeast2 (Jakarta)',
    'australia-southeast1': 'Australia-Southeast1 (Sydney)',
    'australia-southeast2': 'Australia-Southeast2 (Melbourne)',
    'europe-central2': 'Europe-Central2 (Warsaw)',
    'europe-north1': 'Europe-North1 (Finland)',
    'europe-west1': 'Europe-West1 (Belgium)',
    'europe-west2': 'Europe-West2 (London)',
    'europe-west3': 'Europe-West3 (Frankfurt)',
    'europe-west4': 'Europe-West4 (Netherlands)',
    'europe-west6': 'Europe-West6 (Zurich)',
    'northamerica-northeast1': 'Northamerica-Northeast1 (Montréal)',
    'northamerica-northeast2': 'Northamerica-Northeast2 (Toronto)',
    'southamerica-east1': 'Southamerica-East1 (São Paulo)',
    'us-central1': 'US-Central1 (Iowa)',
    'us-east1': 'US-East1 (South Carolina)',
    'us-east4': 'US-East4 (N. Virginia)',
    'us-west1': 'US-West1 (Oregon)',
    'us-west2': 'US-West2 (Los Angeles)',
    'us-west3': 'US-West3 (Salt Lake City)',
    'us-west4': 'US-West4 (Las Vegas)',
  },
  auth0: {
    emailSent: {
      pageTitle: 'Check your inbox!',
      matchingEmail:
        'We just sent you an email to verify your email address. Select the button in the email, and you’re all set!',
      cantFindEmail: 'Can’t find it? ',
      resendEmail: 'Resend the email',
      or: ' or ',
      contactSupport: 'Contact incorta Support',
      returnToHomePage: 'Return to Homepage',
    },
    errorPages: {
      general: {
        returnToLoginPageButton: 'Return back to Login Page',
      },
      blockedUser: {
        headerLine1: 'Your account is blocked!',
        headerLine2: ' ',
        contactSupport: 'Contact us',
        subheader: '  to unblock it.',
      },
      trialExpired: {
        headerLine1: 'Your Trial Expired!',
        headerLine2: 'Want to Extend It?',
        contactSupport: 'Contact Support',
        subheader: ' to extend your trial and explore Incorta further.',
      },
      somethingWentWrongPage: {
        headerLine1: 'Something Went Wrong!',
        headerLine2: ' ',
        contactSupport: 'Contact us',
        subheader: '  for support.',
      },
      personalEmailPage: {
        headerLine1: 'Sign Up Failed!',
        subheader1: 'You can’t sign up here with a personal email address.',
        subheader2: 'Use a work email address.',
      },
      mfaRequired: {
        headerLine1: 'Multifactor authentication required',
      },
    },
  },
  clusterConfiguration: {
    general: {
      clusterMustBeConnectedToChange:
        'Your cluster must be connected to apply this change',
      actionNotSupportedInCurrentPlan: {
        message: "{action} isn't supported with your current plan.",
        clone: 'Clone',
        clusterResize: 'Cluster resize',
        dataApps: 'Data Apps',
        whiteList: 'WhiteList',
        autoSuspend: 'Auto Suspend',
        sqli: 'Sqli',
        dataAgent: 'Data Agent',
        mlFlow: 'MLflow',
        scaling: 'Scaling',
        pythonPackages: 'Python Packages',
        upgrade: 'Upgrade',
        subcluster: 'Subcluster',
      },
    },
    mainTab: {
      update: {
        modalTitle: 'Upgrade',
        byBuildNumber: 'By Build Number',
        buildNumberPlaceholder: 'Incorta-20200601-0949-6111',
        byOfficialRelease: 'By Official Release',
        officialReleaseSelectPlaceholder: 'Select Official Release',
        releaseLabel: 'Release {image} ',
        releaseLatest: '(Latest)',
        releaseWhatsNew: 'What’s New?',
        cancelButton: 'Cancel',
        confirmButton: 'CONFIRM',
        confirmButtonDisabledNoBuildNumber: 'Please enter a build number',
        confirmButtonDisabledNoOfficialReleases:
          'No official releases available',
        confirmMessage:
          'Are you sure you want to save and overwrite this changes?',
        confirmModal: {
          ok: 'CONFIRM CHANGES',
          cancel: 'Cancel',
        },
      },
    },
    configurationsTab: {
      upgradeRequired:
        'You need to upgrade your plan in order to upgrade to this size.',
      disabledClusterSize:
        'This size can be requested on demand, Please contact the support for further assistance.',
      scaling: {
        selectChart: 'Select Chart',
        scalingHistory: 'Auto Scaling History',
        chartType: '{representation} chart',
        selectDuration: 'Select Duration',
        analytics: 'Analytics',
        loader: 'Loader',
        autoScalingSelect: 'Auto Scaling',
        autoScaling: {
          parameters: {
            title: 'Auto Scaling Configurations',
            requestDelay: 'Request Delay: ',
            coolDelay: 'Cooldown delay: ',
            rejectedQueriesUp: 'Rejected queries upscale: ',
            rejectedQueriesDown: 'Rejected queries downscale: ',
            consecutiveQueries: 'Consecutive queries: ',
            units: {
              requestDelay: ' sec',
              coolDelay: ' min',
            },
          },
          legendFormat: 'Replica ',
          rejectedQueriesLegendFormatUnit: ' rejected queries',
          totalQueriesLegendFormatUnit: ' total queries',
          serviceReplicasLegendFormatUnit: ' replicas',
          tooltipFormat: {
            firstLine: 'Replica ',
            secondLine: 'Rejected Queries: ',
            thirdLine: 'Start Time: ',
          },
          xAxis: 'Time',
          yAxis: {
            queries: 'Queries',
            services: 'Services',
          },
          autoScalingHistory: 'Auto Scaling Histogram',
        },
      },
      deltaSharing: {
        configurationsDescription1:
          'Enable this toggle to open secure sharing of Incorta’s Delta Lake data stored in GCS buckets.',
        configurationsDescription2: 'Follow ',
        configurationsDescription3: 'these steps ',
        configurationsDescription4: ' for configurations',
        disabled: 'Delta Sharing has been disabled, Please contact support.',
        unsupportedVersion:
          'Unlock Delta Sharing: Upgrade your cluster today for access. Enhance your data capabilities now!',
        modal: {
          copyWheelFileURL: 'Copy Wheel File URL',
          wheelFileURLCopySuccessful:
            'Wheel File URL has been copied successfully.',
          copyWheelJSON: 'Copy JSON',
          copyInstallCommandWheelFile: 'Copy Command',
          installCommandWheelFile: 'Command copied successfully',
          jSONCopySuccessful: 'JSON has been copied successfully.',
          copySampleCode: 'Copy Sample Code URL',
          sampleCodeCopySuccessful: 'Sample Code URL copied successfully',
          headerFollowInstructions1:
            'Follow the steps below to set up a delta sharing. For more information, visit the ',
          headerFollowInstructions2: 'documentation ',
          headerFollowInstructions3: 'on Delta Sharing.',
          step1: {
            header: 'Download wheel file',
            description:
              'Download the following wheel file to be able to use delta sharing',
          },
          step2: {
            header: 'Install the wheel',
            description:
              'In your preferred IDE/external notebook, install the downloaded wheel by using the following command',
          },
          step3: {
            header: 'Setup the client credentials',
            description:
              'Use the following json snippet to authenticate while upgrading the necessary fields',
            replaceJSONVariables:
              'Replace PERSONAL_ACCESS_TOKEN and TENANT_NAME with yours.',
          },
          step4: {
            header: 'Sample Code',
            description: 'Download the following Notebook ',
          },
        },
      },
    },
    schedulingTab: {
      title: '{status} Scheduled Event',
      new: 'New',
      edit: 'Edit',
      view: 'View',
      actions: {
        connect: 'Connect',
        disconnect: 'Disconnect',
        scaleUp: 'Scale Up',
        scaleDown: 'Scale Down',
      },
      scheduledEventTable: {
        title: 'Events',
        columnLabels: {
          event: 'Action',
          startTime: 'Start Time',
          endTime: 'End Time',
          eventDetails: 'Event Details',
          status: 'Status',
        },
        deleteEvent: 'Delete',
        eventDetailsAnalyticsReplicas: ' Analytics Replicas',
        eventDetailsLoaderReplicas: ' Loader Replicas',
        status: {
          queued: 'Queued',
          success: 'Success',
          failed: 'Failed',
        },
      },
      scheduledEventForm: {
        controls: {
          previous: 'Previous',
          schedule: 'Schedule',
          editSchedule: 'Edit Schedule',
          review: 'Review',
          next: 'Next',
        },
        event: 'Action',
        startTime: 'Start Time',
        startTimeErrorText: 'Please select a date and time after the current',
        scaleStepHint: 'At least set one of Analytics, or Loader Replicas',
        scaleReplicasCounts: {
          current: 'Current Replicas: {currentReplicas}',
          after: ', After Event: {replicasAfterEvent}',
        },
        scaleAnalyticsReplicas: 'Analytics Replicas',
        scaleAnalyticsReplicasPlaceholder:
          'Analytics replicas amount for scaling',
        scaleLoaderReplicas: 'Loader Replicas',
        scaleLoaderReplicasPlaceholder: 'Loader replicas amount for scaling',
        endTime: 'End Time',
        endTimeStepOptional: ' (Optional)',
        endTimeStepHint: 'For rollback, after start time',
        summaryStepTitle: 'Event Summary',
        summaryStepAction: 'Action: ',
        summaryStepStartTime: 'Start Time: ',
        summaryStepEndTime: 'End Time: ',
        summaryStepDetails: 'Details',
        summaryStepAnalyticsReplicas: 'Analytics Replicas: ',
        summaryStepLoaderReplicas: 'Loader Replicas:',
        summaryStepResult: 'Event Result: ',
      },
      message: {
        deleteSuccess: 'Event deleted successfully',
        updateSuccess: 'Event update successfully',
        addSuccess: 'Event created successfully',
      },
    },
    azureSynapse: {
      header: 'Enable Azure Synapse Analytics',
      description:
        'Have the option to choose Azure Synapse Analytics as a Data Destination inside Incorta Analytics.',
      button: {
        enableButton: 'Enable',
        installingButton: 'Installing',
        editButton: 'Edit',
      },
      successMessage: 'Azure Synapse enabled successfully',
    },
    azureSynapseModal: {
      title: 'Enable Azure Synapse Analytics',
      tenantFieldLabel: 'Tenant',
      tenantFieldPlaceholder: 'Tenant Name',
      usernameFieldLabel: 'Username',
      usernameFieldPlaceholder: 'Username',
      passwordFieldLabel: 'Password',
      cancelBtn: 'Cancel',
      submitBtn: 'Submit',
      requiredTenant: 'Please select your tenant!',
      requiredUsername: 'Please input your username!',
      requiredPassword: 'Please input your password!',
    },
    incortaX: {
      title: 'Enable Advanced SQL Interface',
      mainHint: 'Connect to Tableau, Power BI, or other SQL tools.',
      moreHint:
        ' Enabling this feature will enforce the Null Handling feature, ignoring the user-defined Null Handling value.',
    },
    copilot: {
      title: 'Advanced Copilot',
      desription:
        'Enables advanced copilot with planning capability required for some copilots features like Notebooks.',
    },
    copilotModal: {
      title: 'Copilot',
      enable: 'Enable',
      disable: 'Disable',
      openAIApiKey: 'OpenAI API key',
      requiredApiKey: 'API Key is required',
      cancelBtn: 'Cancel',
      submitBtn: 'Save',
      copilotStateMessage: 'Copilot will be ',
      copilotStateWillBeEnabled: 'enabled',
      copilotStateWillBeDisabled: 'disabled',
    },
    titles: {
      clusterSize: 'Cluster Size',
      clusterServicesControl: 'Services',
      analyticsNode: 'Analytics Node',
      loaderNode: 'Loader Node',
      autoSuspend: 'Auto Suspend',
      clusterRegion: 'Cluster Region',
      homePage: 'Home Page',
      deltaSharing: 'Delta Sharing',
      openAI: 'Enable Copilot',
      copilot: 'Copilot',
      externalBITools: 'External BI Tools',
      incortaX: 'Advanced SQL Interface',
      microsoftSynapse: 'Synapse Analytics',
      dataAgent: 'Data Agent',
      pythonPackages: 'Python Packages',
      mlFlow: 'MLflow',
    },
    clusterServicesControl: {
      titles: {
        analytics: 'Analytics',
        loader: 'Loader',
        sqli: 'SQLi',
        notebook: 'Notebook',
        analyticsSubCluster: 'Analytics Subclusters',
        loaderSubCluster: 'Loader Subclusters',
      },
      serviceNames: {
        analytics: 'Analytics Service {number}',
        loader: 'Loader Service {number}',
        sqli: 'SQLi Service',
        notebook: 'Notebook Service',
        analyticsSubCluster: 'Analytics Subcluster {number}',
        loaderSubCluster: 'Analytics Subcluster {number}',
      },
      disconnectedComponent: {
        title: 'Cluster is disconnected',
        description: 'Your cluster must be connected to view these services',
      },
      status: {
        processing: 'Processing',
        startingTenants: 'Starting Tenants',
        startingTenant: 'Starting Tenant',
        isStarting: 'Starting',
        running: 'Started',
        sleeping: 'Sleeping',
        stopping: 'Stopping',
        stoppingTenants: 'Stopping Tenants',
        stoppingTenant: 'Stopping Tenant',
        notRunning: 'Stopped',
        error: 'Error',
        startupError: 'Startup Error',
        notResponding: 'Not Responding',
        TerminatedUnexpectedly: 'Terminated Unexpectedly',
        na: 'N/A',
        creating: 'Creating',
        deleting: 'Deleting',
      },
      headerOptions: {
        tooltipCantAddReachedMaxCount:
          'You’ve reached maximum number of {serviceType} service nodes',
        tooltipCantAddForTrialUser:
          'Only available for Premium users. Chat with us to upgrade.',
        tooltipSubClusterDisconnected:
          'The Subcluster is currently disconnected, Connect it firstly to do the action',
        configureAnalyticsSubCluster: 'Configure',
        addServices: 'Add {serviceName} services',
        analytics: 'analytics',
        loader: 'loader',
        options: {
          startAll: 'Start all',
          stopAll: 'Stop all',
          restartAll: 'Restart all',
          deleteServices: 'Delete services...',
        },
        deleteServices: 'Delete {serviceName} services',
        deleteServiceDropdown: {
          note: 'Note: ',
          message: 'You can’t delete the last service.',
        },
        buttons: {
          add: 'Add',
          cancel: 'Cancel',
          delete: 'Delete',
        },
        messages: {
          addDeleteSuccess:
            '{nodesNumber} {serviceType} service{plural} {operation}',
          operationAdded: 'added',
          operationDeleted: 'deleted',
        },
      },
    },
    pythonPackages: {
      subHeader:
        'Incorta Machine Learning Python Packages are required to be used in the Materialized views.',
      addPackages: {
        title: 'Add Packages',
        placeholder: 'Type and press Space eg., numpy==1.3',
        install: 'Install',
        hint: 'Only packages that are compatible with pip.',
        confirmModal: {
          title: 'Installed Packages Detected',
          content:
            'Please note that {packages} {plural1} already installed, do you want to overwrite {plural2}',
          singular1: 'is',
          plural1: 'are',
          singular2: 'it',
          plural2: 'them',
        },
      },
      installedPackages: {
        title: 'Installed Packages',
        displayVersions: 'Sync Versions',
      },
      editModal: {
        edit: 'Edit',
        title: 'Package Version',
        hint: 'Leave it empty if you want to install the latest version',
        errorLabel:
          'Please enter a valid pacakge version e.g. 1, 1.0 or 1.0.0 or 1.0.0.0',
        reinstall: 'Reinstall',
        editVersion: 'Edit Version',
        delete: 'Delete',
      },
      errorTooltip: {
        analytics: 'Analytics',
        loader: 'Loader',
        reinstall: 'Reinstall',
        status: {
          installing: 'Installing...',
          failed: 'Failed to Install ✗',
          succeeded: 'Installed ✓',
        },
      },
    },
    mlFlow: {
      connectToMLflow: 'Connect to MLflow Portal.',
      enableConnectMLTools:
        'Enable this toggle to connect to machine learning tools.',
    },
  },
  provisionUserModal: {
    title: 'Change Password',
    newPasswordFieldLabel: 'New Password',
    confirmPasswordFieldLabel: 'Confirm Password',
    skipBtn: 'Skip and use current password',
    updateBtn: 'Update Password',
    fillInPasswordErrorMessage: 'Please fill in the password',
    confirmPasswordErrorMessage: 'Please confirm the password',
    passwordsDontMatchErrorMessage: 'Passwords don’t match',
    validatePasswordCriteriaErrorMessage:
      'Enter a password that meets the requirements.',
    changeProvisionUserPassword: {
      successMessage: 'Password successfully changed',
    },
    passwordCriteria: {
      minimumLowercaseLetter: '1 lowercase letter',
      minimumUppercaseLetter: '1 uppercase letter',
      minimumNumber: '1 number',
      minimumSpecialCharacter: '1 special character',
      minimumCharacters: '12 characters minimum',
    },
  },
  myAccount: {
    personalInformation: {
      firstNameFieldLabel: 'First Name',
      firstNameFieldPlaceholder: 'First Name',
      firstNameFieldErrorMessage: 'Please input your first name!',
      lastNameFieldLabel: 'Last Name',
      lastNameFieldPlaceholder: 'Last Name',
      lastNameErrorMessage: 'Please input your last name!',
      jobTitleFieldLabel: 'Job Title',
      jobTitleFieldPlaceholder: 'Job Title',
      jobTitleFieldErrorMessage: 'Please input your job title!',
      companyFieldLabel: 'Company',
      companyFieldPlaceholder: 'Company',
      companyFieldErrorMessage: 'Please input your company!',
      phoneFieldLabel: 'Phone',
      phoneFieldPlaceholder: '+0123456789',
    },
  },
  cloneModal: {
    submitButton: 'SUBMIT',
    cancelButton: 'Cancel',
    clonedClusterNameFieldLabel: 'CLONED CLUSTER NAME',
    successMessage: 'cluster is cloned successfully',
  },
  createNewSubClusterModal: {
    description:
      'Set the name, size and the analytics services number to create your Analytic Subcluster Node, all other configurations are inherited from the main cluster.',
    nameFieldLabel: 'Name',
    nameFieldPlaceholder: 'Incorta-101',
    sizeFieldLabel: 'Sub Cluster Type',
    sizeFieldPlaceholder: 'Select a Type',
    nodesFieldLabel: 'Set number of analytics services',
    nodesFieldError: 'Node number is required',
    saveButton: 'Save',
    createButton: 'Create',
    cancelButton: 'Cancel',
  },
  supportForm: {
    emailFieldLabel: 'Email',
    emailFieldPlaceholder: 'example@mail.com',
    emailFieldNotValidError: 'The input is not valid Email!',
    emailFieldRequiredError: 'Please input your Email!',
    messageFieldLabel: 'Describe Your ISSUE/SUGGESTION',
    messageFieldPlaceholder: 'Issue/Suggestion Description',
    messageFieldError: 'Please input your message',
    sendButton: 'Send',
    cancelButton: 'Cancel',
  },
  userConsentCookiesText: `The website and API use cookies and other tracking technologies to improve the user experience,
   analyze traffic, personalize content, and serve targeted ads. The statement emphasizes the use of both session and persistent cookies,
    as well as third-party cookies. We collect personal data and process data elements in accordance with applicable data protection laws,
     and users can withdraw their consent by contacting {privacyEmail}. Users are encouraged to contact the website via our global privacy policy or API owner with questions or concerns about cookie usage.
      To opt-in or opt-out of Incorta marketing communication,
     click on this link. this statement is governed by our 
     {globalPrivacy} and 
     {cookiesPolicy}`,
};
export default en;
